import { TextInput } from "@mantine/core";
import { IconClock } from "@tabler/icons-react";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePicker, { DateObject } from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";

import type { TimeInputProps } from "./type";

const CustomDatePicker = (DatePicker as unknown as { default?: typeof DatePicker }).default ?? DatePicker;
const CustomTimePicker = (TimePicker as unknown as { default?: typeof TimePicker }).default ?? TimePicker;

export default function TimeInput({
  value,
  onChange,
  placeholder,
  disabled,
  label,
  error,
  withAsterisk,
  ...rest
}: TimeInputProps) {
  const onChangeHandler = (dateObject: DateObject) => {
    if (dateObject) {
      const timeStr = [
        dateObject.hour.toString().padStart(2, "0"),
        dateObject.minute.toString().padStart(2, "0"),
        dateObject.second.toString().padStart(2, "0"),
      ].join(":");

      onChange(timeStr);
    } else {
      onChange(null);
      return;
    }
  };

  const formatValue = (value: string | null) => {
    if (value) {
      const [hour = 0, minute = 0, second = 0] = value.split(":").map(Number);

      const obj = new DateObject({ calendar: persian });
      obj.setHour(hour);
      obj.setMinute(minute);
      obj.setSecond(second);

      return obj;
    } else {
      return undefined;
    }
  };

  return (
    <CustomDatePicker
      value={formatValue(value)}
      onChange={onChangeHandler}
      disableDayPicker
      format="HH:mm:ss"
      containerStyle={{ width: "100%" }}
      plugins={[<CustomTimePicker key="time-picker" />]}
      calendar={persian}
      locale={persian_fa}
      calendarPosition="bottom-center"
      {...rest}
      render={(value, openCalendar) => (
        <TextInput
          label={label}
          onFocus={openCalendar}
          value={value}
          onClick={openCalendar}
          readOnly
          rightSection={<IconClock size={18} />}
          disabled={disabled}
          placeholder={placeholder}
          error={error}
          aria-label={label}
          withAsterisk={withAsterisk}
          size="sm"
        />
      )}
    />
  );
}
